import i18n from '@/plugins/i18n';
export const forms = [
    {
        type: 'multiInput',
        name: 'info',
        default: [{name: '', email: '', phone_no: '', task: ''}],
        title: 'Yetkili Bilgileri',
        modal: ['contact'],
        data:['contact'],
        inputs:[
            {
                type: 'text',
                name: 'name',
                title: i18n.t('dealer.wizzard.userName'),
                rules: {},
                modal: ['name'],
                data: ['name'],
            },
            {
                type: 'text',
                name: 'task',
                title: i18n.t('customer.wizzard.userTask'),
                rules: {},
                modal: ['task'],
                data: ['task'],
            },
            {
                type: 'text',
                name: 'email',
                title: i18n.t('account.user.email'),
                rules: {email: true},
                modal: ['email'],
                data: ['email'],
            },
            {
                type: 'masked',
                name: 'phone_no',
                title: i18n.t('account.user.phone'),
                rules: {},
                mask:'\+\ 11 (111) 111 1111',
                modal: ['phone_no'],
                data: ['phone_no'],
            },
        ],
        additionalButton: false,
        checkBox: false
    },
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/General/Customer/forms/userForm.js